import {
  DateTime,
} from 'luxon';

export const alphSortSearchOptions = (a, b) => (
  a.label?.toLowerCase() > b.label?.toLowerCase() ? 1 : -1
);

export const alphSortByName = (a, b) => (
  a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1
);

export const alphSortByUserName = (a, b) => (
  `${a.user_profile.first_name} ${a.user_profile.last_name}`.toLowerCase()
  > `${b.user_profile.first_name} ${b.user_profile.last_name}`.toLowerCase() ? 1 : -1
);

export const sortByPosition = (a, b) => (
  a.position > b.position ? 1 : -1
);

export const sortByLetter = (a, b) => (
  a.letter > b.letter ? 1 : -1
);

export const sortByDate = (name, reverse = false) => (a, b) => {
  const l = reverse ? 1 : -1;
  const r = reverse ? -1 : 1;
  return DateTime.fromISO(a[name]) > DateTime.fromISO(b[name]) ? l : r;
};

export const sortByOrderName = (
  a: any,
  b: any,
) => a.order_name.toLowerCase().localeCompare(b.order_name.toLowerCase(), undefined, {
  numeric: true,
  sensitivity: 'base',
});

export const getActivityText = (event, item) => {
  const owner = event.owner_full_name;

  if (event.trackable_type === 'User') {
    switch (event.key) {
      case ('user.invitation_accepted'):
        return `${owner} accepted invitation`;
      default:
        return '';
    }
  }

  if (event.trackable_type === 'WorkoutEvent') {
    const createAt = DateTime.fromISO(event.created_at);
    const beginsAt = DateTime.fromISO(event.parent.begins_at);
    const interval = createAt.diff(beginsAt, ['months', 'days', 'hours', 'milliseconds']).toObject();

    const workoutName = item && item.workout_name;
    if (!interval.months
      && !interval.days
      && !interval.hours
      && interval.milliseconds < 1100
      && event.key !== 'workout_event.update'
    ) {
      return `${owner} started ${workoutName}`;
    }
    if (!event.parent.begins_at) {
      return `${owner} scheduled ${workoutName}`;
    }
    switch (event.key) {
      case ('workout_event.update'):
        return `${owner} finished ${workoutName}`;
      case ('workout_event.delete'):
        return `${owner} delete ${workoutName}`;
      default:
        return `${owner} scheduled ${workoutName}`;
    }
  }
  return '';
};

export const getActivityTime = (event) => {
  const start = event.trackable_type === 'WorkoutEvent'
    ? DateTime.fromISO(event.parent.begins_at)
    : DateTime.fromISO(event.created_at);

  const passed = ['years', 'months', 'days', 'hours', 'minutes'];
  const currentTime = DateTime.local();
  const diff = currentTime.diff(start, passed);
  for (let i = 0; i < passed.length; i += 1) {
    const p = passed[i];
    const t = diff[p];
    if (t >= 1) {
      return `${Math.floor(t)} ${p} ago`;
    }
  }

  return 'just now';
};

export const onlyUniqueId = (value, index, self) => (
  self.findIndex(item => item.id === value.id) === index
);
